/**
 * Utilitaires pour les quotes
 * Fonctions pures <20 lignes chacune
 */

export function isMissing(value) {
  return !value || value === '' || value === null || value === undefined
}

/**
 * Génère le contenu du footer d'un devis selon les informations de l'organisateur
 * @param {Object} organisateur - Informations de l'organisateur
 * @param {Object} prix - Informations de prix
 * @returns {string} - Contenu du footer formaté
 */
export function generateQuoteFooterContent(organisateur, prix) {
  const companyName = organisateur?.nom || ''
  const adresse = organisateur?.adresse || '20 avenue des Frères Montgolfier CHASSIEU 69680'
  const siret = organisateur?.siret || ''
  const tva = organisateur?.tva || null
  const tvaLabel = prix?.tvaLabel || ''
  const numeroDeclaration = organisateur?.numeroDeclaration || ''
  
  const siretDisplay = tva 
    ? `SIRET : ${siret} / TVA ${tva}`
    : `SIRET : ${siret}`
  
  const footerLines = [
    companyName,
    adresse,
    siretDisplay,
    tvaLabel,
    `N° de déclaration d'activité : ${numeroDeclaration}`,
    'Cet enregistrement ne vaut pas l\'agrément de l\'État.'
  ]
  
  return footerLines.filter(line => line).join('\n')
}

/**
 * Vérifie si un contenu de footer correspond au format automatique
 * @param {string} content - Contenu à vérifier
 * @returns {boolean} - true si le contenu correspond au format automatique
 */
export function isAutoGeneratedFooter(content) {
  if (!content || !content.trim()) return true
  
  const hasCompanyName = content.includes('ALERTIS')
  const hasSiret = content.includes('SIRET :')
  const hasDeclaration = content.includes('déclaration d\'activité')
  const hasAgreement = content.includes('Cet enregistrement ne vaut pas l\'agrément')
  
  return hasCompanyName && hasSiret && hasDeclaration && hasAgreement
}

/**
 * Calcule le total HT de toutes les lignes de prix d'un devis
 * @param {Array} priceLines - Tableau des lignes de prix
 * @returns {number} - Total HT calculé
 */
export function calculateTotalFromPriceLines(priceLines) {
  if (!priceLines || !Array.isArray(priceLines)) return 0
  
  return priceLines.reduce((sum, line) => {
    const quantite = parseFloat(line.quantite) || 0
    const prixUnitaire = parseFloat(line.prixUnitaire) || 0
    return sum + quantite * prixUnitaire
  }, 0)
}
